import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogAction } from './models';

@Component({
  selector: 'app-base-dialog',
  templateUrl: './base-dialog.component.html',
  styleUrls: ['./base-dialog.component.sass']
})
export class BaseDialogComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() closable: boolean = true;
  @Input() title: string;
  @Input() width: string;
  @Input() actions: DialogAction[] = [];

  @Output() onClose = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {
  }

  handleHide() {
    this.onClose.emit();
  }
}
